import { useContext, useEffect } from 'react';
import { MarketSignalStream } from '@/modules/market-signals/model/market-signals/market-signal-stream';
import { FormSelect } from 'react-bootstrap';
import { MarketSignalContext } from '@/modules/market-signals/contexts/market-signal-context';

export default function MarketSignalStreamSelector({
  onStreamSelect,
}: {
  onStreamSelect?: (s?: MarketSignalStream) => void;
}) {
  const { streams, setSelectedStream, selectedStream } = useContext(MarketSignalContext);

  useEffect(() => {
    if (selectedStream && onStreamSelect) {
      onStreamSelect(streams.find(value => value.code === selectedStream));
    }
  }, [selectedStream, onStreamSelect, streams]);

  useEffect(() => {
    console.log('Streams have changed', streams);
  }, [streams]);

  if (streams.length === 0) return <></>;
  //newly changed selectedStream
  return (
    <>
      <FormSelect onChange={event => setSelectedStream(event.target.value)} value={selectedStream}>
        {streams.map(value => (
          <option key={value.code} value={value.code}>
            {value.name}
          </option>
        ))}
      </FormSelect>
    </>
  );
}
